import { useEffect, useRef, useState } from 'react';
import ResultsMap from './ResultsMap';

const noop = () => {};
export default function SolarReportMap({ inspectionId, layers, rows, status, captureRef, disabled }) {
  // Report framing and visibility must not change the inspection map's controls.
  const [reportLayers, setReportLayers] = useState(() => layers.filter(layer => !layer.savedId));
  const [include, setInclude] = useState(true);
  const mapCapture = useRef(null);
  useEffect(() => {
    const kmz = layers.find(layer => layer.id === 'inspection-kmz');
    if (kmz) setReportLayers(current => current.some(layer => layer.id === kmz.id) ? current : [kmz, ...current]);
  }, [layers]);
  useEffect(() => {
    captureRef.current = async () => {
      if (!include) return null;
      if (!mapCapture.current) throw new Error('Wait for the Location Overview preview to load.');
      return mapCapture.current();
    };
    return () => { captureRef.current = null; };
  }, [include, captureRef]);
  return <section className="solar-report-map" aria-label="Location Overview" style={disabled ? { pointerEvents: 'none' } : undefined}>
    <h4>Location Overview</h4>
    <label><input type="checkbox" disabled={disabled} checked={include} onChange={event => { setInclude(event.target.checked); setReportLayers(current => current.filter(layer => !layer.savedId)); }} /> Use this map view in the report</label>
    <p>{include ? 'Frame the site and choose the visible KMZ or orthomosaic layers. This view will appear in the PDF. Photo markers show capture locations.' : 'The report will use the standard satellite overview when GPS is available.'}</p>
    {include && <ResultsMap key={inspectionId} inspectionId={inspectionId} rows={rows} layers={reportLayers} setLayers={setReportLayers} status={status} readOnly reportMode captureRef={mapCapture} onSelect={noop} onOpen={noop} />}
  </section>;
}
